import * as React from "react";

export const useConstructor = (callBack = () => {}) => {
  const hasBeenCalled = React.useRef(false);

  if (hasBeenCalled.current) {
    return;
  }

  callBack();
  hasBeenCalled.current = true;
};
